import { createStyles, rem, Tabs, Text, Center } from "@mantine/core";
import { useSearchParams } from "react-router-dom";
import { pageTopSpacing } from "../../constant/Responsive";
import SectionHeader from "../layout/SectionHeader";
import PageContainer from "../layout/PageContainer";
import ProductGrid from "./ProductGrid";
import product_info, { filterProductsByCategory } from "../../constant/ProductInfo";
import { PRODUCT_CATEGORIES } from "../../constant/productCategories";

const useStyles = createStyles((theme) => ({
  wrapper: {
    paddingBottom: rem(48),
  },
  tabs: {
    marginBottom: theme.spacing.lg,
  },
  tab: {
    fontSize: theme.fontSizes.sm,
    fontWeight: 500,
    letterSpacing: "0.04em",
    padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
    "&[data-active]": {
      color: theme.colors.orange[7],
      borderColor: theme.colors.orange[6],
      backgroundColor: theme.colors.orange[0],
    },
  },
  deliveryNote: {
    marginBottom: theme.spacing.lg,
    padding: theme.spacing.sm,
    fontSize: theme.fontSizes.sm,
    color: theme.colors.gray[6],
    lineHeight: 1.6,
    borderLeft: `3px solid ${theme.colors.orange[4]}`,
    paddingLeft: theme.spacing.md,
  },
  empty: {
    padding: theme.spacing.xl,
    color: theme.colors.gray[6],
    textAlign: "center",
  },
}));

export default function ProductGallery() {
  const { classes } = useStyles();
  const [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get("category") || "all";
  const filtered = filterProductsByCategory(product_info, category);

  const handleCategoryChange = (value) => {
    const next = new URLSearchParams(searchParams);
    if (value === "all") {
      next.delete("category");
    } else {
      next.set("category", value);
    }
    setSearchParams(next, { replace: true });
  };

  return (
    <PageContainer className={classes.wrapper} pt={pageTopSpacing()} pb="xl">
      <SectionHeader
        order={1}
        title="零售及批發產品"
        subtitle="馬來西亞 D197 貓山王、D200 黑刺鮮果，以及急凍產品。適用於即食、烘烤及雪糕餡料。"
      />

      <Text className={classes.deliveryNote}>
        急凍產品預約送貨（不包括馬灣、愉景灣、離島及上樓）。WhatsApp 9831 2915 預訂。
      </Text>

      <Tabs
        value={category}
        onTabChange={handleCategoryChange}
        className={classes.tabs}
        variant="outline"
        radius="md"
        color="orange"
      >
        <Tabs.List grow>
          {PRODUCT_CATEGORIES.map((cat) => (
            <Tabs.Tab key={cat.id} value={cat.id} className={classes.tab}>
              {cat.label}
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs>

      {filtered.length > 0 ? (
        <ProductGrid products={filtered} />
      ) : (
        <Center className={classes.empty}>
          <Text>此分類暫無產品，請瀏覽其他分類。</Text>
        </Center>
      )}
    </PageContainer>
  );
}
